  function switchProduct(clickedElement, mainProductId, relatedProductId) {

      // Busca los productos dentro del contenedor más cercano
      const mainProduct = clickedElement.closest(`[data-product-id="${mainProductId}"]`);
      const relatedProduct = document.querySelector(`[data-product-id="${relatedProductId}"]`);
    
      if (mainProduct && relatedProduct) {
      

        mainProduct.style.display = 'none';
        relatedProduct.style.display = 'block';


        
      }
    
  }

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList') {
      const formEmbedElement = document.querySelector('form-embed');
      if (formEmbedElement) {
        const shadowRoot = formEmbedElement.shadowRoot;


            
            const formFieldContainers = shadowRoot.querySelectorAll('._textBody_2aowh_10');

            const departamento = shadowRoot.querySelector('._textHeading_2aowh_35');
            const checkform = shadowRoot.querySelector('legend._textBody_2aowh_10._checkboxLegend_171zd_18');

            
            departamento.style.cssText = `
                    font-weight: 200;
                    font-size: 18px;
                    font-family: 'ZonaPro';
                
              `;

            formFieldContainers.forEach(container => {
              container.style.cssText = `
                font-weight: 200;
                    font-size: 12px;
                    font-family: 'ZonaPro';
              `;
            });



                    checkform.style.cssText = `
                    display: none;
                
              `;
          
        
      }
    }
  });
});

// Configurar el observador
observer.observe(document.body, { childList: true, subtree: true });